<template>
  <form-box
    title="股东信息"
    :button-text="type === 'check' ? '' : '增加股东'"
    @add="addShareholderInfo"
  >
    <template v-if="shareholderInfoFormArr && shareholderInfoFormArr.length">
      <div
        v-for="(item, index) in shareholderInfoFormArr"
        :key="index"
        class="form-content"
      >
        <el-form
          :ref="`shareholderInfoForm${index}`"
          class="form-box"
          size="medium"
          label-position="top"
          :rules="rules"
          :model="item"
        >
          <div class="delete-btn" v-if="type !== 'check'">
            <span @click="deleteShareholderInfo(index)"
              ><i class="el-icon-delete"></i>删除</span
            >
          </div>
          <div class="form-row">
            <!-- 左侧表单 -->
            <div class="form-column">
              <el-form-item label="证件类型">
                <el-select
                  :disabled="type === 'check'"
                  v-model="item.documentType"
                  placeholder="请选择证件类型"
                >
                  <el-option
                    v-for="item in allSelectData.shareholderDocumentTypeArr"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="占股比例" prop="bankingRatio">
                <el-input
                  v-model="item.bankingRatio"
                  :disabled="type === 'check'"
                  class="ipt"
                  maxlength="10"
                  placeholder="请输入占股比例"
                >
                  <template slot="append">%</template>
                </el-input>
              </el-form-item>
            </div>
            <!-- 右侧表单 -->
            <div class="form-column">
              <el-form-item label="证件号码">
                <el-input
                  v-model="item.documentCode"
                  :disabled="type === 'check'"
                  class="ipt"
                  maxlength="30"
                  placeholder="请输入证件号码"
                >
                </el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <Empty v-else emptyTxt="暂无股东信息"></Empty>
  </form-box>
</template>

<script>
import FormBox from "./FormBox.vue";
import Empty from "./Empty.vue";
export default {
  name: "PlantInfo",
  components: {
    FormBox,
    Empty,
  },
  props: {
    shareholderInfoFormArr: {
      type: Array,
      default() {
        return [];
      },
    },
    allSelectData: {
      type: Object,
      default() {
        return {};
      },
    },
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    const validateNumAndEmpty = (rule, value, callback) => {
      const pattern = /^\d{0,10}(\.\d{0,2})?$/g;
      if (value && !pattern.test(value)) {
        callback(
          new Error(`${rule.message}必须为数字（整数或保留两位小数）或者空`)
        );
      }
      callback();
    };
    return {
      rules: {
        bankingRatio: [
          {
            trigger: "blur",
            message: "占股比例必须为数字（整数或保留两位小数）",
            validator: validateNumAndEmpty,
          },
        ],
      },
    };
  },
  methods: {
    addShareholderInfo() {
      this.$emit("add", "shareholderInfoDTOList");
    },
    deleteShareholderInfo(index) {
      this.$emit("delete", "shareholderInfoDTOList", index);
    },
  },
};
</script>

<style scoped lang="scss">
.form-content {
  background: #f7f9fb;
  margin-bottom: 20px;
  .form-box {
    .delete-btn {
      text-align: right;
      font-size: 14px;
      color: #ff5c5c;
      padding: 18px 16px 0 0;
      span {
        cursor: pointer;
      }
      i {
        font-size: 18px;
        margin-right: 4px;
      }
    }
    .form-row {
      display: flex;

      .form-column {
        padding: 40px 0 30px 100px;
        flex: 1;
        ::v-deep .el-form-item__label {
          line-height: normal !important;
        }
        .ipt,
        .el-select {
          width: 374px;
        }
      }
    }
  }
}
</style>
